module.exports = __webpack_public_path__ + "static/media/Vidro.d9646be0.jpeg";